<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M27 17H5a1 1 0 010-2h22a1 1 0 010 2z"/></svg>
</template>

<script>
export default {
  name: 'symbolsMinusOutline'
}
</script>
